import { api } from "./api";

interface BillingData {
  BillingTypeId: number;
  BillingTypeName: string;
  Billing: number;
  Paid: number;
  Outstanding: number;
}

interface BillingResponse {
  billingDatas: BillingData[];
  TotalBilling: number;
  TotalPaid: number;
  TotalOutstanding: number;
  DueDate: string;
  LastUpdate: string;
  Code: number;
  Message: string;
}

export const GetBillingData = async (isreload: boolean = false): Promise<BillingResponse | null> => {
  try {
    const tenantid =
      localStorage.getItem("tenant_id") ||
      sessionStorage.getItem("tenant_id");

    if (!tenantid) {
      console.log("tenant_id not found in storage");
      return null;
    }

    const url = `/dashboard/v2/billing?tenantid=${tenantid}&isreload=${isreload ? 1 : 0}`;
    const response = await api.get<BillingResponse>(url);

    if (response.status === 200 && response.data) {
      return response.data;
    }

    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};